import { useEffect, useState } from 'react';

import type Paginated from 'app/core/paginable';
import { useGetApplication } from 'app/hooks';
import { type TaxReturn } from 'app/modules/Reports/TaxReturnList/types';
import { BaseUrlTaxReturnPayment } from 'app/modules/Taxpayer/Payments/TaxReturnPayment/http';
import {
  type TaxReturnPayment,
  type TemplateWeb
} from 'app/modules/Taxpayer/Payments/TaxReturnPayment/types';
import { type ResponseValues } from 'axios-hooks';
import moment from 'moment';

import { baseUrlTaxreturns } from '@/app/modules/Reports/TaxReturnList/services/taxReturn.service';

import { getNotes } from './service';
const idWithoutData = '01660e23-d782-40f3-9c67-6c0537f64aa9';

export const useGetTotalDebtByCurrentTaxpayer = (taxReturnId: string) => {
  const [{ data, loading, error }] = useGetApplication<{ totalDebt: number }>({
    url: `/taxpayers/tax-returns/${taxReturnId}/total-debt`,
    params: {}
  });

  return { loading, error, totalDebt: data?.totalDebt ?? 0 };
};

export const useGetTaxreturnByCurrentTaxpayer = (id: string) => {
  const taxreturnId = id ? id : idWithoutData;
  const [{ data, loading, error }] = useGetApplication<Paginated<TaxReturn>>({
    url: `${baseUrlTaxreturns}/from/taxpayer`,
    params: { page: 1, pageSize: 1, id: taxreturnId, relations: ['FormVersion.Form'] }
  });

  const [taxreturn] = data?.data || [];
  return { loading, error, taxreturn };
};

const defaultRelations = ['Currency', 'PaymentMethod', 'TaxReturn', 'TaxReturn.Taxpayer'];
export const useGetTaxreturnPaymentByCurrentTaxpayer = (
  id: string
): ResponseValues<TaxReturnPayment, any, any> => {
  const paymentId = id ? id : idWithoutData;
  const [{ data, loading, error }] = useGetApplication<Paginated<TaxReturnPayment>>({
    url: `${BaseUrlTaxReturnPayment}/current/taxpayer`,
    params: { page: 1, pageSize: 1, id: paymentId, relations: defaultRelations }
  });

  const [payment] = data?.data || [];
  return {
    loading,
    error,
    data: (payment
      ? {
          ...payment,
          createdDate: moment(payment.createdDate).toDate()
        }
      : undefined) as TaxReturnPayment
  } as ResponseValues<TaxReturnPayment, any, any>;
};

export const useGetNotes: (language: string) => {
  loading: boolean;
  data: TemplateWeb;
} = (language: string) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<TemplateWeb>({ name: '', html: '' });

  useEffect(() => {
    getNotes(language).then((notes: TemplateWeb) => {
      setLoading(false);
      setData(notes);
    });
  }, []);

  return { loading, data };
};
